// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"d2b91ab8","285":"64032331","458":"a67903db","500":"d8c5b96e","774":"edfb9be5","787":"ab1d5502","851":"da137fc7","858":"f15636a6"}[chunkId] + ".chunk.js";
};